export default __webpack_public_path__ + "static/media/Done.cddad024.svg";